import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { BASE_URL, extractId, fetcher, sendData } from "../../Models/Fetcher";
import OmniumTypesDisplay from "../OmniumTypesDisplay";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import LockIcon from "@material-ui/icons/Lock";

import ButtonGroup from "@material-ui/core/ButtonGroup";

import "./styles.css";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { codeTableTypeState, selectedTypesState } from "../../Store/atoms";
import RecordsTable from "../RecordsTable";
import Loading from "../Utilities/Loading";
import { Button, makeStyles } from "@material-ui/core";
import DescAccordion from "./DescAccordion";
import Type3Table from "../Type3Table";
import Error from "../Error";

const useStyles = makeStyles({
  expandIcon: {
    "&:hover": {
      cursor: "pointer",
    },
  },
});

export default () => {
  const location = useLocation();
  const classes = useStyles();

  const tableId = extractId(location.pathname);
  const [selectedTypes, setSelectedTypes] = useRecoilState(selectedTypesState);

  const [table, setTable] = useState<any>(null);
  const [expanded, setExpanded] = useState(false);
  const [favorite, setFavorite] = useState(false);
  const [error, setError] = useState<any>(null);

  const [codeTableType, setCodeTableType] = useRecoilState(codeTableTypeState);
  const url = BASE_URL + "codetables/" + tableId;

  useEffect(() => {
    fetcher(url).then((res) => {
      console.log(res);
      if (res.status !== 200) {
        setError({ message: res.data.message, status: res.status });
      }
      setTable(res.data);
      setFavorite(res.data.favorite);
    });
  }, [url]);

  useEffect(() => {
    setSelectedTypes([]);
  }, [codeTableType]);

  const handleExpand = async () => {
    setExpanded((expanded) => !expanded);
  };
  if (!table) {
    return <Loading />;
  }

  if (error) {
    return (
      <Error
        code={error.status}
        message={error.message}
        resetUser={false}
        button={{ text: "Back to My tables", route: "/favorites" }}
      />
    );
  }

  const handleType2 = () => {
    setSelectedTypes([]);

    setCodeTableType(2);
  };

  const handleType3 = () => {
    setSelectedTypes([]);

    setCodeTableType(3);
  };

  const type2URL = BASE_URL + "codetables/" + table.id + "/omnium-types-2";
  const type3URL = BASE_URL + "codetables/" + table.id + "/omnium-types-3";

  return (
    <div className="table-view">
      <div className="table-control-header">
        <div className="table-name" onClick={handleExpand}>
          {table.locked && (
            <LockIcon fontSize="large" style={{ marginRight: "1rem" }} />
          )}
          <div className="table__name">{"Table: " + table.name}</div>

          {expanded ? (
            <ExpandLessIcon className={classes.expandIcon} fontSize="large" />
          ) : (
            <ExpandMoreIcon className={classes.expandIcon} fontSize="large" />
          )}
        </div>

        <div className="table-type-control">
          <ButtonGroup
            color="primary"
            aria-label="outlined secondary button group"
          >
            <Button
              variant={codeTableType === 3 ? "outlined" : "contained"}
              onClick={handleType2}
              size="large"
            >
              Type2
            </Button>
            <Button
              variant={codeTableType === 2 ? "outlined" : "contained"}
              onClick={handleType3}
              size="large"
            >
              Type3
            </Button>
          </ButtonGroup>
        </div>
      </div>

      {expanded && (
        <DescAccordion
          setFavorite={setFavorite}
          favorite={favorite}
          table={table}
        />
      )}

      <div className="table-view--container">
        <div className="types-selection">
          <OmniumTypesDisplay
            url={codeTableType === 3 ? type3URL : type2URL}
            type={codeTableType === 3 ? "3" : "2"}
            locked={table.locked}
          />
        </div>
        <div className="records-table">
          {codeTableType === 2 &&
            selectedTypes.map((type) => {
              return (
                <RecordsTable key={type.id} type={type} locked={table.locked} />
              );
            })}

          {codeTableType === 3 &&
            selectedTypes.map((type) => {
              return (
                <Type3Table key={type.id} type={type} locked={table.locked} />
              );
            })}
        </div>
      </div>
    </div>
  );
};
